import { tagsModel } from '../../api';
import { sendEventToJumbo } from '../../helpers/analytics';

export const addManualTag = (url, data) => (dispatch) => {
  return tagsModel
    .addManualTag(url, data)
    .then((response) => {
      if (!response) return;
      sendEventToJumbo('added_manual_tag_successfully');
      return response;
    })
    .catch((error) => {
      sendEventToJumbo('failed_to_add_manual_tag');
      console.log('Add manual tag error', error);
    });
};

export const SET_TAGS = 'SET_TAGS';
export const setTags = (tags) => ({
  type: SET_TAGS,
  tags,
});

export const getTags = (params) => (dispatch) => {
  let tagsObj = {};
  const orderId = params['order_id'];
  return tagsModel
    .getTags(params)
    .then((response) => {
      if (!response) return;
      sendEventToJumbo('get_tag_success');
      tagsObj[orderId] = response;
      dispatch(setTags(tagsObj));
    })
    .catch((err) => {
      sendEventToJumbo('get_tag_failed');
      console.log('tags error', err);
    });
};
